<template>
  <form
    class="sales-note"
    @submit.prevent="onSubmit"
  >
    <div class="columns is-multiline is-centered">
      <div class="column is-12">
        <VoucherDetails
          :disabled="isLoading || stamped"
          :is-loading="isLoading"
        />
      </div>
      <div class="column is-12">
        <Concepts
          v-if="!isLoading"
          :is-loading="isLoading"
          :disabled="isLoading || stamped"
        />
      </div>

      <div class="column is-12 action-buttons">
        <div
          v-if="stamped || canceled"
          class="field is-grouped"
        >
          <p class="control">
            <RouterLink
              class="button"
              :class="{ 'is-loading': isLoading }"
              :disabled="isLoading"
              :to="{ name: 'SaleNoteList' }"
            >
              Regresar
            </RouterLink>
          </p>
        </div>
        <div
          v-else
          class="field is-grouped"
        >
          <p class="control">
            <RouterLink
              class="button"
              :class="{ 'is-loading': isLoading }"
              :disabled="isLoading"
              :to="{ name: 'SaleNoteList' }"
            >
              Regresar
            </RouterLink>
          </p>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import moment from 'moment';

export default {
  name: 'SaleNoteDetail',
  components: {
    VoucherDetails: () => import(/* webpackChunkName: "invoice-voucher-details" */ '@/components/Admin/Invoices/NewSaleNote/SaleNoteDetails.vue'),
    Concepts: () => import(/* webpackChunkName: "invoice-concepts" */ '@/components/Admin/Invoices/NewSaleNote/SaleNoteConcepts.vue'),
  },
  data() {
    return {
      isLoading: false,
      stamp: false,
    };
  },
  computed: {
    ...mapState({
      stamped: state => state.invoice.operation.isSaleNote,
      status: state => state.invoice.operation.status,
    }),
    canceled() {
      return [201, 202].includes(this.status);
    },
  },
  async beforeMount() {
    this.isLoading = true;
    await this.getInvoiceByUuid(this.$route.params.uuid);
    if (!this.stamped) {
      this.setValue({
        accessor: 'voucherDate',
        value: moment().format('YYYY-MM-DDTHH:mm'),
      });
    }
    this.isLoading = false;
  },
  methods: {
    ...mapMutations({
      setValue: 'invoice/setValue',
      setInitialState: 'invoice/setInitialState',
    }),
    ...mapActions({
      getInvoiceByUuid: 'invoice/getByUuid',
      updateInvoice: 'invoice/updateByUuid',
    }),
    setStamp(value) {
      this.stamp = value;
    },
    async onSubmit() {
      this.isLoading = true;
      const { stamp } = this;
      try {
        await this.updateInvoice({
          uuid: this.$route.params.uuid,
          stamp,
        });
        this.$store.dispatch('addTemporalNotification', {
          type: 'success',
          content: stamp ? 'Timbrado exitoso' : 'Guardado correctamente',
        });
        this.isLoading = false;
        this.setInitialState();
        this.$router.push({
          name: 'InvoicesHistory',
          redirect: { name: 'SaleNoteList', query: { size: 20, page: 1 } },
        });
      } catch (error) {
        this.$store.dispatch('addTemporalNotification', {
          type: 'danger',
          content: stamp
            ? error.message
            : 'Ocurrio un error al guardar.',
        });
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.sales-note {
  padding: 1rem;
}

.action-buttons {
  display: flex;
  justify-content: flex-end;
}

@media screen and (min-width: 1280px) {
  .box {
    flex-direction: column;
  }

  .label.is-centered::before {
    top: inherit;
  }
}
</style>
